<template>
  <div>
    <Form
      :create="false"
      :description-title="'Atualizar dados da avaliação'"
    >
      <CreateButton
        @click="updateAssessment()"
        :icon="PhNotePencil"
        :label="'Atualizar'"
      />
    </Form>
  </div>
</template>

<script setup>
import ExtinguisherService from '../service/extinguisher.service'
import CreateButton from '@/components/Buttons/Create.vue'
import Form from '../components/RegisterForm.vue'
import {
  cleanAllFormFields,
  setFormFieldsError,
  validateFormField
} from '@/helpers/formFieldsHandler'
import { showToast as toast } from '@/helpers/UseToasts'
import { PhNotePencil } from '@phosphor-icons/vue'
import { dataExtinguisher } from '../store'
import { storeApp } from '@/store'
import * as yup from '@/validator'
import { onBeforeMount } from 'vue'

const store = dataExtinguisher.state
const appStore = storeApp.state

const schema = yup.object().shape({
  form: yup.object().shape({
    title: yup.string().required('Informe um titulo').label('Titulo'),
    min_grade_required: yup.number().required('Informe a pontuação minima'),
    max_grade: yup.number().required('Informe a nota máxima'),
    max_attempts: yup.number().required('Informe o numero de tentativas'),
    event_id: yup.array().required('Treinamento é obrigatório')
  })
})

async function updateAssessment () {
  appStore.loading = true

  cleanAllFormFields()
  const validate = await validateFormField(schema, store)

  if (validate && validate.length > 0) {
    setFormFieldsError(validate)
    appStore.loading = false
    return
  }

  await ExtinguisherService.update(store.form)
    .then((res) => {
      if (res?.data?.success) {
        toast('Sucesso', res?.data?.message, 'success')

        Promise.allSettled([
          ExtinguisherService.listAssessment().then((res) => {
            dataExtinguisher.dispatch('setAllAssessments', res.data)
          })
        ])
      }

      appStore.loading = false
    })
    .catch((err) => {
      appStore.loading = false

      if (err?.response?.data?.error && err.response.data.status === 400) {
        return toast('Aviso', err.response.data.message, 'error')
      }

      return toast('Aviso', 'Algo deu errado ao alterar avaliação', 'error')
    })
}

onBeforeMount(async () => {
  appStore.loading = true
  dataExtinguisher.dispatch('getComboQuestion')
  appStore.loading = false
})

</script>
